var pet_sizes ={
  pet_sizes: {
    tiny: {
    txt_id: "tiny",
    name: "Tiny"
    },
    small: {
    txt_id: "small",
    name: "Small"
    },
    medium: {
    txt_id: "medium",
    name: "Medium"
    },
    large: {
    txt_id: "large",
    name: "Large"
    }
  }
}

module.exports = pet_sizes
